import ImagesPressIconsLetterSvg from '@/public/images/press/icons/letter.svg';
import ImagesPressIconsLinkedInIconCircleSvg from '@/public/images/press/icons/LinkedIn_icon_circle.svg';
import ImagesPressIconsLinkedinSvg from '@/public/images/press/icons/linkedin.svg';
import ImagesPressIconsPhoneSvg from '@/public/images/press/icons/phone.svg';

export {
  ImagesPressIconsLetterSvg,
  ImagesPressIconsLinkedInIconCircleSvg,
  ImagesPressIconsLinkedinSvg,
  ImagesPressIconsPhoneSvg,
};
